//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'MDRD',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '0',
        item4: '0',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res
        console.log('form', form);
        console.log(1, Math.pow(form.item2 / 88.4, -1.154));
        console.log(2, Math.pow(form.item1 / 88.4, -0.203));
        if (form.item3 == 0 && form.item4 == 0) {
          console.log(111);
          res = 186 * Math.pow(form.item2 / 88.4, -1.154) * Math.pow(form.item1, -0.203)
        }
        if (form.item3 == 0 && form.item4 == 1) {
          console.log(222);
          res = 186 * Math.pow(form.item2 / 88.4, -1.154) * Math.pow(form.item1, -0.203) * 1.21
        }
        if (form.item3 == 1 && form.item4 == 0) {
          console.log(333);
          res = 186 * Math.pow(form.item2 / 88.4, -1.154) * Math.pow(form.item1, -0.203) * 0.742
        }
        if (form.item3 == 1 && form.item4 == 1) {
          console.log(444);
          res = 186 * Math.pow(form.item2 / 88.4, -1.154) * Math.pow(form.item1, -0.203) * 0.742 * 1.21
        }

        self.hasScore = true
        return String(res.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/MDRD.vue